import React from 'react';
import { motion } from 'framer-motion';
const points = ["Nights lost searching for progressions that actually work, flow, and match your students' specific level", 'Classes that feel repetitive — because you keep going back to the same moves you already know', 'Visible improvisation that quietly erodes your confidence as an instructor', 'No variety between weeks — and students who slowly lose motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging, or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-175" data-mp="1nzjyma8lb3ae">
      <div className="max-w-3xl mx-auto" data-id="element-176" data-mp="1o0vdp67hjxgt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177" data-mp="1o1wr3hbz4w1p">
          <h2 className="text-3xl md:text-4xl font-serif font-bold uppercase mb-6 text-ink" data-id="element-178" data-mp="3ibibcm63yhb1">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-ink-soft leading-relaxed bg-cream-light p-6 rounded-2xl border border-line text-left shadow-sm" data-id="element-179" data-mp="1yzvgtbwa4dra">
            Sunday night. 10 PM. You have a hip hop class tomorrow morning. And
            you're still there — scrolling through videos, trying to build a
            class structure that actually flows — one that matches your
            students' level, feels professional, and doesn't look like you put
            it together in twenty minutes.
            <br data-id="element-180" data-mp="1b39axb3zvv7z" />
            <br data-id="element-181" data-mp="1b3rhb0kdfptm" />
            <span className="text-burgundy font-semibold" data-id="element-182" data-mp="1b4anjk0nsprt">
              Not because you don't know hip hop.
            </span>{' '}
            Because nobody ever gave you a complete, structured, ready-to-teach
            system. You've been building every single class from scratch. The
            time you should be resting — you're spending it planning. And the
            worst part isn't the exhaustion. The worst part is walking into the
            studio feeling like you could have been better prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183" data-mp="1y3zt59iwckg2">
          <h3 className="text-xl font-bold uppercase text-ink mb-8 text-center" data-id="element-184" data-mp="274xxjsx8ytz6">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-185" data-mp="1afyr8jg8429m">
            {points.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-cream-light p-4 rounded-xl border border-burgundy/25 shadow-sm" data-id="element-186" data-mp="1ehahmr6x8riv" data-mpi={i}>
                <span className="mt-1" aria-hidden="true" data-id="element-187" data-mp="vphpt03l9ccq">
                  🔴
                </span>
                <span className="text-ink-soft" data-id="element-188" data-mp="o603xg2vgad0">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-line" data-id="element-189" data-mp="j6vtyn84i8lm">
            <p className="text-2xl font-serif font-bold uppercase text-burgundy" data-id="element-190" data-mp="e82ggusu6hlg">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-ink" data-id="element-191" data-mp="58fn8wa9gi3h">
              Solve an entire year of hip hop dance classes in just 5 minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}